// extracted by mini-css-extract-plugin
export var contentBox = "about-section-module--contentBox--zt3TB";
export var img = "about-section-module--img--umnA8";
export var imgBox = "about-section-module--imgBox--bEmoI";
export var reverse = "about-section-module--reverse--QTfmW";
export var row = "about-section-module--row--A5k6r";
export var titleBox = "about-section-module--titleBox--vRU8j";